class StickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.sentinel = null;
    this.content = null;
    this.hasBeenTriggered = false;
    this.sentinelInView = true;
    this.sentinelObserver = null;
  }

  connectedCallback() {
    this.sentinel = this.previousElementSibling;
    this.content = this.querySelector('.sticky-add-to-cart__content');

    if (!this.sentinel || !this.content) return;

    requestAnimationFrame(() => {
      this.style.minHeight = `${this.offsetHeight}px`;
      this.#initObserver();
    });
  }

  disconnectedCallback() {
    this.sentinelObserver?.disconnect();
  }

  #initObserver() {
    this.sentinelObserver = new IntersectionObserver(([entry]) => {
      this.sentinelInView = entry.isIntersecting;

      if (this.sentinelInView) {
        this.hasBeenTriggered = true;
      }

      this.#updateDisplay();
    });

    this.sentinelObserver.observe(this.sentinel);
  }

  #updateDisplay() {
    const shouldBeActive = this.hasBeenTriggered && !this.sentinelInView;
    const isActive = this.dataset.active === 'true';

    if (shouldBeActive === isActive) return;

    clearTimeout(this.closingTimeout);

    if (shouldBeActive) {
      delete this.dataset.closing;
      this.dataset.active = 'true';
      this.content.classList.add('color-scheme-1');
      return;
    }

    this.dataset.active = 'false';
    this.dataset.closing = 'true';

    this.closingTimeout = setTimeout(() => {
      delete this.dataset.closing;
      this.content.classList.remove('color-scheme-1');
    }, 300);
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}